import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon';

type BadgeVariant = 'success' | 'warning' | 'danger' | 'info' | 'default';
type BadgeSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-badge',
  standalone: true,
  imports: [CommonModule, IconComponent],
  template: `
    <span [class]="getBadgeClasses()">
      <app-icon
        *ngIf="icon"
        [name]="icon"
        [className]="getIconSize()"
      ></app-icon>
      <ng-content></ng-content>
    </span>
  `
})
export class BadgeComponent {
  @Input() variant: BadgeVariant = 'default';
  @Input() size: BadgeSize = 'md';
  @Input() icon?: string;
  @Input() className: string = '';

  getBadgeClasses(): string {
    const baseClasses = 'inline-flex items-center gap-1 font-semibold rounded-md';

    const variantClasses = {
      success: 'bg-emerald-600 text-white',
      warning: 'bg-amber-500 text-white',
      danger: 'bg-red-600 text-white',
      info: 'bg-blue-600 text-white',
      default: 'bg-gray-200 text-gray-800'
    };

    const sizeClasses = {
      sm: 'px-2 py-0.5 text-xs',
      md: 'px-3 py-1 text-sm',
      lg: 'px-4 py-1.5 text-base'
    };

    return `${baseClasses} ${variantClasses[this.variant]} ${sizeClasses[this.size]} ${this.className}`;
  }

  getIconSize(): string {
    const sizes = {
      sm: 'w-2.5 h-2.5',
      md: 'w-3 h-3',
      lg: 'w-4 h-4'
    };
    return sizes[this.size];
  }
}
